<template lang="pug">
b-modal#addThemeContent(
  ref="addThemeContent"
  :title="$t('ui.combine.add_content')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.theme_code')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="theme_code"
        required
        type="text"
        :dirty="$v.theme_code.$dirty"
        :error="$v.theme_code.$error"
        v-model.trim.lazy="$v.theme_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.theme_code" :name="$t('ui.theme_code')")
    b-form-group(:label="$tc('ui.content_id')").mb-1
      ThemeContentLookup(
        ref="content_id"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.content_id.$dirty"
        :error="$v.content_id.$error"
        v-model.trim.lazy="$v.content_id.$model"
      )
      ValidateResult(:value="$v.content_id" :name="$t('ui.content_id')")
    b-form-group(:label="$tc('ui.content_group')").mb-1
      ThemeContentGroupLookup(
        ref="content_group"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.content_group.$dirty"
        :error="$v.content_group.$error"
        v-model.trim.lazy="$v.content_group.$model"
      )
      ValidateResult(:value="$v.content_group" :name="$t('ui.content_group')")
    b-form-group(:label="$tc('ui.position')").mb-1
      ThemeContentPositionLookup(
        ref="position"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.position.$dirty"
        :error="$v.position.$error"
        v-model.trim.lazy="$v.position.$model"
      )
      ValidateResult(:value="$v.position" :name="$t('ui.position')")
    template(v-if="isThemeHide == 'false'")
      b-form-group(:label="$t('ui.sync_site_content')").mb-1
        label.custom-switch
          input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="sync_exist")
          span.custom-switch-indicator

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import ThemeContentPositionLookup from "@/library/ThemeContentPositionLookup";
import ThemeContentLookup from "@/library/ThemeContentLookup";
import ThemeContentGroupLookup from "@/library/ThemeContentGroupLookup";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    ThemeContentPositionLookup,
    ThemeContentLookup,
    ThemeContentGroupLookup
  },
  props: {
    item: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      position: '',
      content_id: '',
      content_group: '',
      theme_code: '',
      sync_exist: false,
      isThemeHide: config.isThemeHide
    };
  },
  validations: {
    position: {
      required
    },
    content_id: {
      required
    },
    content_group: {
      required
    },
    theme_code: {
      required
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addThemeContentUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          theme_code: this.theme_code,
          theme_content_group: this.content_group,
          position: this.position,
          content_id: this.content_id,
          sync_exist_site_content: this.sync_exist
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "combine.add_content", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.addThemeContent.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.addThemeContent.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.content_id = "";
      this.content_group = "";
      this.position = "";
      this.theme_code = "";
      this.sync_exist = false,
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.theme_code = this.item;
      this.$refs.content_id.$el.focus();
    }
  }
};
</script>
